import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PhoneNumberAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-executive-associate-phone-number-audit-list',
  templateUrl: './person-profile-executive-associate-phone-number-audit-list.component.html',
  styleUrls: ['./person-profile-executive-associate-phone-number-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileExecutiveAssociatePhoneNumberAuditListComponent implements OnInit {
  @Input() executiveAssociatePhoneNumber: number;
  @Input() loading: boolean;
  @Input() executiveAssociatePhoneNumberAudits: PhoneNumberAudit[];

  @Output() loadExecutiveAssociatePhoneNumberAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadExecutiveAssociatePhoneNumberAudits.emit(this.executiveAssociatePhoneNumber);
  }

  onNextPage() {
    this.nextPage.emit(this.executiveAssociatePhoneNumber);
  }
}
